import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
  Legend,
} from "recharts";
import { currency } from "../lib/api";

// Chart palette (index 1 is the debt line colour). The actual colours are
// --chart-1…8 in index.css, so they switch with light/dark mode.
export const NEST_COLORS = [1, 2, 3, 4, 5, 6, 7, 8].map((i) => `var(--chart-${i})`);

export const CHART_GRID = "var(--chart-grid)";
export const CHART_AXIS = "var(--chart-axis)";
export const CHART_TOOLTIP = {
  borderRadius: 14,
  border: "1px solid var(--nest-line)",
  background: "var(--glass-bg-strong)",
  color: "rgb(var(--nest-ink))",
  backdropFilter: "blur(12px)",
  WebkitBackdropFilter: "blur(12px)",
  fontSize: 12,
};

const TooltipCard = ({ active, payload }) => {
  if (!active || !payload?.length) return null;
  const p = payload[0];
  return (
    <div className="nest-glass-strong rounded-xl shadow-md border border-nest-line px-4 py-2.5 text-sm">
      <div className="font-medium text-nest-ink">{p.name}</div>
      <div className="text-nest-muted tabular">{currency(p.value)}</div>
    </div>
  );
};

export default function NestPie({ data, testId, height = 300 }) {
  const total = data.reduce((s, d) => s + d.value, 0);
  if (!data.length || total === 0) {
    return (
      <div
        data-testid={testId}
        className="flex items-center justify-center text-nest-faint text-sm"
        style={{ height }}
      >
        No data yet
      </div>
    );
  }
  return (
    <div data-testid={testId} style={{ width: "100%", height }}>
      <ResponsiveContainer>
        <PieChart>
          <Pie
            data={data}
            innerRadius="60%"
            outerRadius="90%"
            paddingAngle={2}
            dataKey="value"
            stroke="none"
          >
            {data.map((_, i) => (
              <Cell key={i} fill={NEST_COLORS[i % NEST_COLORS.length]} />
            ))}
          </Pie>
          <Tooltip content={<TooltipCard />} />
          <Legend
            iconType="circle"
            wrapperStyle={{ fontSize: 12, color: CHART_AXIS }}
          />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}
